<p>{{ 'test.ui.testPageWorks' | transloco }}</p>

<!-- TIPS: "prefix: 'test' " da usare per far funzionare le traduzioni-->
<ng-container *transloco="let t; prefix: 'test'">

    <!-- traduzione semplice per test caricamento lazy -->
    <h1>{{ 'test.ui.heading' | transloco: { value0: (t('heading')) } }}</h1>
    <h2>{{ 'test.ui.description' | transloco: { value0: (t('description')) } }}</h2>

    <!--Selettore lingua, in attesa di informazioni su dove posizionarlo-->
    <select id="lang" [(ngModel)]="currentLang" (ngModelChange)="setLang($event)">
      <option *ngFor="let lang of languages" [ngValue]="lang">
        {{ t(lang) }}
      </option>
    </select>

    <!-- localizzazione dati -->
    <p>{{ today | translocoDate: { dateStyle: 'long' } }}</p>
    <p>{{ price | translocoCurrency }}</p>
    <p>{{ price | translocoCurrency: 'symbol': {} : 'EUR' }}</p> <!--Workaround per utilizzare valuta differente dalla locale-->
    <p>{{ price | translocoCurrency: 'code': {} : 'EUR' }}</p>

    <!-- pluralizzazione -->
    <p>{{ t('itemCount', { count }) }}</p>
    <button (click)="increment()">+1</button>

    <!-- maschile, femminile, altro -->
    <div>
        <label for="gender">{{ 'test.ui.selezionaGenere' | transloco }}</label>
        <select id="gender" [(ngModel)]="gender">
          <!-- <option value="male">{{ t('gender.male') }}</option> -->
          <option value="male">{{ t('gender.male') }}</option>
          <option value="female">{{ t('gender.female') }}</option>
          <option value="other">{{ t('gender.other') }}</option>
        </select>
    </div>

    <p>{{ t('icu.select', { gender, product: 'Q8 Oils' }) }}</p>
</ng-container>
